export const getEpisodeMetadata = async (episodeID) => {
	const data = new FormData();
	data.append('action', window.podcastComponent.ajax_action);
	data.append('episode_id', episodeID);

	return fetch(window.podcastComponent.ajax_url, {
		method: 'POST',
		body: data,
	})
		.then((res) => res.json())
		.then((data) => {
			return data;
		})
		.catch((e) => {
			console.error(e);
		});
};
